// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"dfb5dd3f","218":"85f14b94","464":"93168827"}[chunkId] + ".css";
};